import React from 'react'
import { useTranslation } from 'react-i18next'

import ThermalPrint, { ThermalPrintButton, useThermalPrint } from 'pages/parts/ThermalPrint'

import { formatDate, formatInventoryQty } from 'helpers/helpers'

function Index({ showRightBar, setShowRightBar, data }) {
	const { t } = useTranslation()
	const { printRef, handlePrint } = useThermalPrint()

	const elements = data?.elements || []
	const countedQuantity = elements.reduce((total, item) => total + Number(item.actual_balance || 0), 0)

	return (
		<>
			<div className="right-sidebar-background" onClick={() => setShowRightBar(!showRightBar)}></div>
			<div className="right-sidebar p-2">
				<div className="position-relative">
					<div className="px-2"
						style={{
							position: 'absolute',
							top: '0',
							right: '0',
							zIndex: 2,
						}}>
						<ThermalPrintButton onClick={handlePrint} />
					</div>

					<h4 className="fw-600 pe-5">{t('document_from')} {formatDate(data.created_at, 'dd.MM.yy HH:mm')}</h4>
					<div className="flex-column preview-info">
						<div className="d-flex gap-2">
							<div className="fw-600">{t('pos')}:</div>
							<div>{data.pos_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('wms')}:</div>
							<div>{data.wms_name}</div>
						</div>
						<div className="d-flex gap-2">
							<div className="fw-600">{t('note')}:</div>
							<div>{data.note}</div>
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '60%' }}>{t('name2')}</th>
									<th style={{ 'width': '15%' }} className="text-nowrap">{t('unit')}</th>
									<th style={{ 'width': '25%' }} className="text-end text-nowrap">{t('counted')}</th>
								</tr>
							</thead>
							<tbody>
								{elements.map((item, index) => (
									<tr key={item.id || index}>
										<td className="text-center" title={item.id}>{index + 1}</td>
										<td>{item.name}</td>
										<td>{item.unit_name}</td>
										<td className="text-end">{formatInventoryQty(item.actual_balance)}</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td className="text-end text-nowrap">
										<b>{formatInventoryQty(countedQuantity)}</b>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<ThermalPrint
				printRef={printRef}
				title={`${t('document_from')} ${formatDate(data.created_at, 'dd.MM.yy HH:mm')}`}
				info={[
					{ label: t('pos'), value: data.pos_name },
					{ label: t('wms'), value: data.wms_name },
					{ label: t('note'), value: data.note },
				]}
				columns={[
					{ label: t('name2'), width: '60%', numbered: true, render: (item) => item.name },
					{ label: t('unit'), width: '16%', render: (item) => item.unit_name },
					{ label: t('counted'), width: '24%', align: 'end', render: (item) => formatInventoryQty(item.actual_balance) },
				]}
				rows={elements}
				total={[t('total'), '', formatInventoryQty(countedQuantity)]}
			/>
		</>
	)
}

export default Index
